import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';

/** The part of the backend's /buildProperties payload the footer shows. */
export interface BuildInformation {
  version?: string;
}

@Injectable({ providedIn: 'root' })
export class BuildService {

  private readonly http = inject(HttpClient);

  private readonly base = '/api/buildProperties';

  /** The Maven version the backend was built from, or null when it is not known. */
  version(): Observable<string | null> {
    return this.http.get<BuildInformation>(this.base).pipe(map(info => info?.version ?? null));
  }
}
